import React from 'react';
import './PickDelivery.scss';
import FormattedText from 'Components/Shared/FormattedText/FormattedText';
import DeliveryItem from 'Components/PickDelivery/DeliveryItem';

interface IProps {
  selectedDeliveryCode: string;
  deliveryMethods: Julius.Website.DeliveryMethodViewModel[];
  onDeliveryItemChange: (deliveryCode: string, isChecked: boolean) => void;
}

const PickDelivery: React.SFC<IProps> = ({
  deliveryMethods,
  selectedDeliveryCode,
  onDeliveryItemChange,
}) => {

  if (!deliveryMethods || !deliveryMethods.length) {
    return null;
  }

  return (
    <div className='pick-delivery'>
      <FormattedText 
        style='title'
        displayName='Leverans'
        formattedName='order.delivery.header'
      />
      { deliveryMethods.map(d => 
        <DeliveryItem 
          key={ d.code }
          isSelected={ d.code === selectedDeliveryCode }
          { ... { ...d, onDeliveryItemChange } }
        />)
      }
    </div>
  );
}

export default PickDelivery;


// WEBPACK FOOTER //
// ./src/components/PickDelivery/PickDelivery.tsx